import React from 'react';

export default function Radio(props) {
  const {label, description, name, value, checked} = props;
  return (
    <div className="radio">
      <label>
        <input defaultChecked={checked} id={name + '-' + value} type="radio" name={name} value={value} />
        <span>{label}</span>
      </label>
      {description && (
        <div className="description">
          {description}
        </div>
      )}
    </div>
  );
}
